@if (currentSnapshot && hasVisibleFields) {
  <app-card class="flex-basis-100 mb-12">
    <div cardRows class="card__rows w-100">
      <div class="card__rows">
        <div
          class="card__row"
          *ngIf="currentData.insuranceType || baselineData.insuranceType"
        >
          <span class="card__label" i18n>Type d'assurance</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.insuranceType,
                  baselineData.insuranceType
                ),
              }"
            >
              {{ getInsuranceTypeDisplayLabel(currentData.insuranceType) }}
            </span>
            <span
              class="old-lead-value"
              *ngIf="
                isChanged(currentData.insuranceType, baselineData.insuranceType)
              "
            >
              {{ getInsuranceTypeDisplayLabel(baselineData.insuranceType) }}
            </span>
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="currentData.startDate || baselineData.startDate"
        >
          <span class="card__label" i18n>Date de debut</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.startDate,
                  baselineData.startDate
                ),
              }"
              >{{ currentData.startDate || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="isChanged(currentData.startDate, baselineData.startDate)"
              >{{ baselineData.startDate || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="currentData.endDate || baselineData.endDate"
        >
          <span class="card__label" i18n>Date de fin</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.endDate,
                  baselineData.endDate
                ),
              }"
              >{{ currentData.endDate || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="isChanged(currentData.endDate, baselineData.endDate)"
              >{{ baselineData.endDate || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            currentData.offerSignatureDate || baselineData.offerSignatureDate
          "
        >
          <span class="card__label" i18n>Date de signature</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.offerSignatureDate,
                  baselineData.offerSignatureDate
                ),
              }"
              >{{ currentData.offerSignatureDate || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                isChanged(
                  currentData.offerSignatureDate,
                  baselineData.offerSignatureDate
                )
              "
              >{{ baselineData.offerSignatureDate || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="currentData.periodicity || baselineData.periodicity"
        >
          <span class="card__label" i18n>Periodicite</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.periodicity,
                  baselineData.periodicity
                ),
              }"
            >
              {{ getPeriodicityDisplayLabel(currentData.periodicity) }}
            </span>
            <span
              class="old-lead-value"
              *ngIf="
                isChanged(currentData.periodicity, baselineData.periodicity)
              "
            >
              {{ getPeriodicityDisplayLabel(baselineData.periodicity) }}
            </span>
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            currentData.coversPeriodicity || baselineData.coversPeriodicity
          "
        >
          <span class="card__label" i18n>Périodicité des couvertures</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.coversPeriodicity,
                  baselineData.coversPeriodicity
                ),
              }"
            >
              {{ getPeriodicityDisplayLabel(currentData.coversPeriodicity) }}
            </span>
            <span
              class="old-lead-value"
              *ngIf="
                isChanged(
                  currentData.coversPeriodicity,
                  baselineData.coversPeriodicity
                )
              "
            >
              {{ getPeriodicityDisplayLabel(baselineData.coversPeriodicity) }}
            </span>
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="currentData.category || baselineData.category"
        >
          <span class="card__label" i18n>Categorie</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.category,
                  baselineData.category
                ),
              }"
              >{{ currentData.category || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="isChanged(currentData.category, baselineData.category)"
              >{{ baselineData.category || '-' }}</span
            >
          </div>
        </div>
      </div>

      <div class="card__rows">
        <div
          class="card__row"
          *ngIf="currentData.subcategory || baselineData.subcategory"
        >
          <span class="card__label" i18n>Sous-categorie</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.subcategory,
                  baselineData.subcategory
                ),
              }"
              >{{ currentData.subcategory || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                isChanged(currentData.subcategory, baselineData.subcategory)
              "
              >{{ baselineData.subcategory || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            (currentData.productItems?.length ?? 0) > 0 ||
            (baselineData.productItems?.length ?? 0) > 0
          "
        >
          <span class="card__label" i18n>Produits</span>
          <div class="card__value">
            <app-proposal-products
              [productDetailsList]="currentData.productItems || []"
              [comparisonProductDetailsList]="
                compare ? baselineData.productItems || [] : null
              "
            />
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="currentData.premiumAmount || baselineData.premiumAmount"
        >
          <span class="card__label" i18n>Prime</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.premiumAmount,
                  baselineData.premiumAmount
                ),
              }"
              >{{ currentData.premiumAmount || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                isChanged(currentData.premiumAmount, baselineData.premiumAmount)
              "
              >{{ baselineData.premiumAmount || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            currentData.totalPremiumAmount || baselineData.totalPremiumAmount
          "
        >
          <span class="card__label" i18n>Prime totale</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.totalPremiumAmount,
                  baselineData.totalPremiumAmount
                ),
              }"
              >{{ currentData.totalPremiumAmount || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="
                isChanged(
                  currentData.totalPremiumAmount,
                  baselineData.totalPremiumAmount
                )
              "
              >{{ baselineData.totalPremiumAmount || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            !isPolicyCreated &&
            (currentData.keyFeatures || baselineData.keyFeatures)
          "
        >
          <span class="card__label" i18n>Caracteristiques clé</span>
          <div class="d-flex gap-2 flex-column card__value">
            @if (currentData.keyFeatures) {
              <div
                [ngClass]="{
                  'new-lead-value': isChanged(
                    currentData.keyFeatures,
                    baselineData.keyFeatures
                  ),
                }"
                [innerHtml]="currentData.keyFeatures"
              ></div>
            } @else {
              <span>-</span>
            }
            @if (isChanged(currentData.keyFeatures, baselineData.keyFeatures)) {
              @if (baselineData.keyFeatures) {
                <div
                  class="old-lead-value"
                  [innerHtml]="baselineData.keyFeatures"
                ></div>
              } @else {
                <span class="old-lead-value">-</span>
              }
            }
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            !isPolicyCreated &&
            (currentData.productBenefits || baselineData.productBenefits)
          "
        >
          <span class="card__label" i18n>Avantages produit</span>
          <div class="d-flex gap-2 flex-column card__value">
            @if (currentData.productBenefits) {
              <div
                [ngClass]="{
                  'new-lead-value': isChanged(
                    currentData.productBenefits,
                    baselineData.productBenefits
                  ),
                }"
                [innerHtml]="currentData.productBenefits"
              ></div>
            } @else {
              <span>-</span>
            }
            @if (
              isChanged(
                currentData.productBenefits,
                baselineData.productBenefits
              )
            ) {
              @if (baselineData.productBenefits) {
                <div
                  class="old-lead-value"
                  [innerHtml]="baselineData.productBenefits"
                ></div>
              } @else {
                <span class="old-lead-value">-</span>
              }
            }
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            !isPolicyCreated && (currentData.keyTags || baselineData.keyTags)
          "
        >
          <span class="card__label" i18n>Mots clés</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.keyTags,
                  baselineData.keyTags
                ),
              }"
              >{{ currentData.keyTags || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="isChanged(currentData.keyTags, baselineData.keyTags)"
              >{{ baselineData.keyTags || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            !isPolicyCreated && (currentData.offerId || baselineData.offerId)
          "
        >
          <span class="card__label" i18n>N° offre</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.offerId,
                  baselineData.offerId
                ),
              }"
              >{{ currentData.offerId || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="isChanged(currentData.offerId, baselineData.offerId)"
              >{{ baselineData.offerId || '-' }}</span
            >
          </div>
        </div>
        <div
          class="card__row"
          *ngIf="
            isPolicyCreated && (currentData.policyId || baselineData.policyId)
          "
        >
          <span class="card__label" i18n>N° police</span>
          <div class="d-flex gap-2 flex-column card__value">
            <span
              [ngClass]="{
                'new-lead-value': isChanged(
                  currentData.policyId,
                  baselineData.policyId
                ),
              }"
              >{{ currentData.policyId || '-' }}</span
            >
            <span
              class="old-lead-value"
              *ngIf="isChanged(currentData.policyId, baselineData.policyId)"
              >{{ baselineData.policyId || '-' }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div cardRows class="card__rows w-100 mt-12">
      <div class="card__rows w-100">
        <div
          class="card__row"
          *ngIf="
            !isPolicyCreated &&
            (currentData.policyDocItems?.length ||
              baselineData.policyDocItems?.length)
          "
        >
          <span class="card__label" i18n>Documents offre</span>
          <div class="d-flex gap-2 flex-column card__value">
            <div
              class="d-flex gap-1 flex-column"
              *ngIf="
                currentData.policyDocItems?.length;
                else noPolicyCurrentDocs
              "
            >
              @for (
                document of currentData.policyDocItems;
                track document;
                let index = $index
              ) {
                <button
                  type="button"
                  class="btn btn-link p-0 text-start"
                  [ngClass]="{
                    'new-lead-value': areDocumentListsChanged(
                      currentData.policyDocItems,
                      baselineData.policyDocItems
                    ),
                  }"
                  (click)="openDocument(document)"
                >
                  Document {{ index + 1 }}
                </button>
              }
            </div>
            <ng-template #noPolicyCurrentDocs>
              <span>-</span>
            </ng-template>

            <div
              class="d-flex gap-1 flex-column"
              *ngIf="
                areDocumentListsChanged(
                  currentData.policyDocItems,
                  baselineData.policyDocItems
                )
              "
            >
              @for (
                document of baselineData.policyDocItems;
                track document;
                let index = $index
              ) {
                <button
                  type="button"
                  class="btn btn-link p-0 text-start"
                  (click)="openDocument(document)"
                >
                  <span class="old-lead-value">Document {{ index + 1 }}</span>
                </button>
              } @empty {
                <span class="old-lead-value">-</span>
              }
            </div>
          </div>
        </div>

        <div
          class="card__row"
          *ngIf="
            currentData.contractDocItems?.length ||
            baselineData.contractDocItems?.length
          "
        >
          <span class="card__label" i18n>Documents police</span>
          <div class="d-flex gap-2 flex-column card__value">
            <div
              class="d-flex gap-1 flex-column"
              *ngIf="
                currentData.contractDocItems?.length;
                else noContractCurrentDocs
              "
            >
              @for (
                document of currentData.contractDocItems;
                track document;
                let index = $index
              ) {
                <button
                  type="button"
                  class="btn btn-link p-0 text-start"
                  [ngClass]="{
                    'new-lead-value': areDocumentListsChanged(
                      currentData.contractDocItems,
                      baselineData.contractDocItems
                    ),
                  }"
                  (click)="openDocument(document)"
                >
                  Document {{ index + 1 }}
                </button>
              }
            </div>
            <ng-template #noContractCurrentDocs>
              <span>-</span>
            </ng-template>

            <div
              class="d-flex gap-1 flex-column"
              *ngIf="
                areDocumentListsChanged(
                  currentData.contractDocItems,
                  baselineData.contractDocItems
                )
              "
            >
              @for (
                document of baselineData.contractDocItems;
                track document;
                let index = $index
              ) {
                <button
                  type="button"
                  class="btn btn-link p-0 text-start"
                  (click)="openDocument(document)"
                >
                  <span class="old-lead-value">Document {{ index + 1 }}</span>
                </button>
              } @empty {
                <span class="old-lead-value">-</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-card>
}

<app-pdf-viewer-modal #pdfViewer />
